import script from "./MemberAccountForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberAccountForm.vue?vue&type=script&setup=true&lang=js"

import "./MemberAccountForm.vue?vue&type=style&index=0&id=109a5429&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-109a5429"]])

export default __exports__